<template>
  <div class="aboutUs">
    <div class="center">
      <div style="height: 25px;width: 100%;"></div>
      <div class="topMsg">
        {{ topContent }}
      </div>
      <div class="block block1">
        <div class="title">{{ title1 }}</div>
        <div class="line"></div>
        <div class="advantage" v-for="(item, index) in fxAdvantage" :key="index">
          <p>
            <span>{{ item.top }}</span
            >{{ item.content }}
          </p>
        </div>
      </div>
      <div class="block">
        <div class="title">{{ title2 }}</div>
        <div class="line"></div>
        <div class="code">
          <img src="@imgs/home/ewm2.jpg" />
        </div>
        <div class="advantage" v-for="(item, index) in fxOfficial" :key="index">
          <p>
            <span>{{ item.top }}</span
            >{{ item.content }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'aboutUs',
  data() {
    return {
      topContent: '云阅读是方正推出的一款轻量级的H5电子书刊发布平台，适用于杂志期刊、报纸、图书、企业内刊、宣传画册等各类形态内容的数字化发布及运营。',
      title1: '云阅读具备的优势',
      title2: '关注方正飞翔官方微信公众号',
      fxAdvantage: [
        {
          top: '极简操作：',
          content: '无需安装软件、不用编程、只需一键导入PDF，就能制作完成！'
        },
        {
          top: '高度仿真：',
          content: '采用3D引擎渲染技术，还原纸质书刊翻页效果，体验不失真！'
        },
        {
          top: '编辑灵活：',
          content: '支持自定义背景图、加载页效果、logo图标与链接地址、还可创建编辑多级目录，方便易用；'
        },
        {
          top: '更新便捷：',
          content: '随时随地修改内容，覆盖文件即可更新，无需担心错字、漏字！'
        },
        {
          top: '开放传播：',
          content: '生成永久链接和二维码，支持在微信/手机/电脑/平板上阅读与传播！'
        },
        {
          top: '完美兼容：',
          content: '适配PC/Pad/手机等各类终端设备，打造一致性阅读体验！'
        },
        {
          top: '专辑/图书馆：',
          content: '将书刊分类收纳、自定义图书排序、设置封面标签，实现个性化管理！'
        },
        {
          top: '数据分析：',
          content: '实时监测各项指标数据，为您构建用户画像、深度了解读者特征！'
        }
      ],
      fxOfficial: [
        {
          top: '云阅读官网：',
          content: 'www.founderfx.cn'
        },
        {
          top: '云阅读产品咨询：',
          content: '010-82531402或13436861163'
        },
        {
          top: '云阅读 QQ咨询：',
          content: '873504364或1436492035'
        }
      ]
    }
  },
  created() {
    document.body.style.minWidth = 'auto'
  }
}
</script>

<style lang="scss" scoped>
.aboutUs {
  // padding: 40px 0;
  overflow: auto;
  // -webkit-overflow-scrolling: touch;
  .center {
    width: 85.3%;
    margin: 0 auto;
    background: none;
    .topMsg {
      font-size: 14px;
      line-height: 20px;
      color: #515151;
      margin-bottom: 20px;
    }
    .block {
      .title {
        font-size: 14px;
        font-weight: 600;
        color: #515151;
      }
      .line {
        height: 1px;
        width: 100%;
        background: #eaeaea;
        margin: 10px 0;
      }
      p {
        font-size: 14px;
        color: #515151;
        line-height: 20px;
      }
      .code {
        padding: 5px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          height: 150px;
        }
      }
    }
    .block1 {
      margin-bottom: 20px;
    }
  }
}
</style>
